import React from "react";
import ContactLeft from "../components/ContactLeft";
import ContactRight from "../components/ContactRight";
import "../style/Contact.css";

function Contact({ setMode }) {
  return (
    <div
      className="contact_container"
      id="contact_page"
      style={{ backgroundColor: setMode[1], color: setMode[0] }}
    >
      <ContactLeft setMode={setMode} />
      <div className="vert_line"></div>
      <ContactRight setMode={setMode} />
    </div>
  );
}

export default Contact;
